import { LoaderFunctionArgs } from "react-router-dom";
import { lecturerManageCoursesLoaderDTO } from "../types/lecturerManageCourse";
import { apiEndpoints } from "@/services/api/api";
import { PublishStatusEnum } from "../enums/publishStatusEnum";

const statusStringToEnum: Record<string, number> = {
  draft: PublishStatusEnum.Draft,
  published: PublishStatusEnum.Published,
  archived: PublishStatusEnum.Archived,
};

export const lecturerManageCoursesLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<lecturerManageCoursesLoaderDTO> => {
  const url = new URL(request.url);
  const page = Number(url.searchParams.get("page") ?? 1);
  const search = url.searchParams.get("search") ?? "";
  const statusParam = url.searchParams.get("publishStatus") ?? "all";
  const publishStatus = statusStringToEnum[statusParam] ?? null;

  const response = await apiEndpoints.lecturerGetCourses({
    pageNumber: page,
    pageSize: 10,
    search: search || null,
    publishStatus,
  });

  if (!response.success) {
    throw new Error(response.message);
  }

  return response.data;
};
